<dx-drop-down-box #dropdown
                  [dataSource]="dataSource"
                  [(value)]="value"
                  valueExpr="value"
                  displayExpr="displayValue"
                  searchExpr="displayValue"
                  placeholder=""
                  [readOnly]="readOnly"
                  [showClearButton]="!readOnly && !templateView"
                  [showDropDownButton]="!readOnly"
                  [acceptCustomValue]="acceptCustomValue"
                  [(opened)]="opened"
                  (onValueChanged)="valueChanged($event)"
                  (onCustomItemCreating)="customItemCreating($event)">
  <!-- Template für den Listeninhalt -->
  <div *dxTemplate="let item of 'content'">
    <dx-list [searchEnabled]="true"
             [dataSource]="dataSource"
             searchExpr="displayValue"
             displayExpr="displayValue"
             valueExpr="value"
             [selectionMode]="selectionMode"
             (onItemClick)="itemClick($event)">
    </dx-list>
  </div>

  <!-- Beispiel: Async Validator, falls du das nutzen möchtest -->
  <dx-validator *ngIf="!templateView && fieldName && validationCallback"
                [validationGroup]="validationGroup"
                (onInitialized)="validationService.startAutomaticValidation($event)">
    <dxi-validation-rule type="async"
                         [validationCallback]="validationCallback"></dxi-validation-rule>
  </dx-validator>
</dx-drop-down-box>
